import React from "react";

const ServiceCard = ({ icon: Icon, title, description }) => {
  return (
    <article className="htb-card htb-service-card group h-full rounded-2xl border border-slate-200 bg-white p-6 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:border-brand-200 hover:shadow-lift sm:p-8">
      <div className="htb-icon-box mb-6 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-50 text-brand-600 transition-all duration-300 group-hover:bg-brand-600 group-hover:text-white">
        <Icon className="h-6 w-6" aria-hidden="true" />
      </div>
      <h3 className="htb-card-title font-display text-[24px] font-medium leading-tight text-slate-900">
        {title}
      </h3>
      <p className="htb-card-text mt-3 text-base leading-7 text-slate-600">{description}</p>
    </article>
  );
};

export default ServiceCard;
